module.exports = __webpack_public_path__ + "static/img/logo.b3f61c72.png";